var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrappert"},[_c('img',{ref:"gamecanvas",attrs:{"src":"http://placehold.it/500x500?text=i_r_canvas"}}),_vm._v(" "),_c('v-snowsplosion',{ref:"splosion",attrs:{"size":_vm.snowWidth * 2,"complexity":1,"autoAnimate":true,"autoFadeOut":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bec6b564","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/Sanity.vue
// module id = null
// module chunks = 